import { type TranslationTree } from '@/i18n/types';

export const messages = {
  redirecting: {
    one: 'Você será redirecionado automaticamente para o login em 1 segundo.',
    other: 'Você será redirecionado automaticamente para o login em {{count}} segundos.',
  },
  resendActivation: 'Reenviar e-mail de ativação',
  retryActivation: 'Tentar ativar novamente',
  signUpAgain: 'Criar conta novamente',
  openMyEmail: 'Abrir meu e-mail',
  backToSignIn: 'Voltar ao login',
  activated: 'Conta ativada com sucesso',
  requestReceived: 'Solicitação recebida',
  resendError: 'Não foi possível reenviar o e-mail de ativação',
  activating: 'Ativando conta',
  requestReceivedTitle: 'Solicitação recebida',
  invalidLink: 'Link inválido',
  activationFailed: 'Não foi possível ativar',
  activatedTitle: 'Conta ativada',
  activatingHint: 'Ativando a sua conta…',
  resendHint:
    'Se este cadastro ainda estiver pendente, enviaremos um novo link de ativação. Confira também a caixa de spam.',
  invalidLinkHint: 'O link de ativação é inválido ou expirou',
  activatedHint: 'Agora entre e conte sobre a sua organização.',
} satisfies TranslationTree;
